import Is from 'core/utility/is'
import React from 'react'
import {Link as RouterLink} from 'react-router-dom'
import {getAppPath, getCurrentAppName} from '../apps'
import {LinkProps} from '../types'
import {concatPath} from '../helpers'
import {hasInitialLocaleCode} from '../navigator'
import {getCurrentLocaleCode} from '../../localization'

export const Link = React.forwardRef((props: LinkProps, ref) => {
  let {
    to,
    href,
    localeCode,
    mailTo,
    tel,
    newTab = false,
    relative = true,
    onClick,
    app = getCurrentAppName(),
    ...otherProps
  } = props

  const path = () => {
    if (!to && href) {
      to = href
    }

    if (!to) {
      to = ''
    }

    if (mailTo) {
      return 'mailto:' + mailTo
    }

    if (tel) {
      return 'tel:' + tel
    }

    if (Is.url(to)) {
      relative = false
    }

    // if not relative, then use the normal anchor tag
    if (!relative) {
      return to
    }

    if (!localeCode && hasInitialLocaleCode()) {
      localeCode = getCurrentLocaleCode()
    }

    let path = concatPath(getAppPath(app), to)

    if (localeCode) {
      path = concatPath(localeCode, path)
    }

    return concatPath(path)
  }

  // if (onClick) {
  //   return <a onClick={onClick as any} {...otherProps} />
  // }

  if (newTab) otherProps.target = '_blank'

  if (otherProps.target) {
    otherProps.rel = 'noopener noreferrer'
  }

  if (mailTo || tel) {
    return <a href={path()} {...otherProps} ref={ref as any} />
  }

  return <RouterLink onClick={onClick as any} to={path()} {...otherProps} />
})

export default Link
